// PRO Services Form Data

export const emirates = [
  { value: 'dubai', label: 'Dubai' },
  { value: 'abu-dhabi', label: 'Abu Dhabi' },
  { value: 'sharjah', label: 'Sharjah' },
  { value: 'ajman', label: 'Ajman' },
  { value: 'ras-al-khaimah', label: 'Ras Al Khaimah' },
  { value: 'fujairah', label: 'Fujairah' },
  { value: 'umm-al-quwain', label: 'Umm Al Quwain' },
];

export const requestVolumeOptions = [
  {
    value: '1-3',
    label: '1 to 3 / month',
    description: 'Suitable for small teams with occasional PRO needs',
  },
  {
    value: '3-10',
    label: '3 to 10 / month',
    description: 'Ideal for growing businesses with regular requirements',
  },
  {
    value: '10+',
    label: 'Above 10 / month',
    description: 'For established companies with frequent PRO activities',
  },
];

export const proServices = [
  { value: 'employment-visas', label: 'Employment Visas' },
  { value: 'investor-visas', label: 'Investor Visas' },
  { value: 'golden-visas', label: 'Golden Visas' },
  { value: 'visit-visas', label: 'Visit Visas' },
  { value: 'visa-renewals', label: 'Visa Renewals' },
  { value: 'license-renewals', label: 'License Renewals' },
  { value: 'document-attestation', label: 'Document Attestation' },
  { value: 'translation-services', label: 'Translation Services' },
  { value: 'emirates-id', label: 'Emirates ID Services' },
  { value: 'labor-card', label: 'Labor Card Services' },
  { value: 'medical-fitness', label: 'Medical Fitness Tests' },
  { value: 'tenancy-contracts', label: 'Tenancy Contracts (EJARI)' },
];

export const proStaffingOptions = [
  {
    value: 'yes-inhouse',
    label: 'Yes, In-house',
    description: 'We have an in-house PRO service provider',
  },
  {
    value: 'yes-outsourced',
    label: 'Yes, Outsourced',
    description: 'We work with an outsourced PRO service provider',
  },
  {
    value: 'no',
    label: 'No, I need help',
    description: 'We need assistance with PRO services',
  },
];

export const packageTypeOptions = [
  {
    value: 'monthly',
    label: 'Monthly Package',
    description: 'Ongoing support with monthly retainer - Best value for regular needs',
    icon: '📅',
  },
  {
    value: 'one-time',
    label: 'One-Time Service',
    description: 'Pay per request as needed - Flexible for occasional requirements',
    icon: '⚡',
  },
];

export const employeeSizeOptions = [
  { value: '1-10', label: '1-10 employees' },
  { value: '11-50', label: '11-50 employees' },
  { value: '51-200', label: '51-200 employees' },
  { value: '201-500', label: '201-500 employees' },
  { value: '500+', label: '500+ employees' },
];
